import React from 'react';

import { ApiVolcanoId } from '@vona/shared';
import { GetVolcanoIdsResponseZod } from '@vona/shared/GetVolcanoIds';

import { useApi } from '../context/ApiProvider';

type UseVolcanoesResult = {
  error?: Error;
  loading: boolean;
  volcanoes: ApiVolcanoId[];
};

export const useVolcanoes = (): UseVolcanoesResult => {
  const [error, setError] = React.useState<Error>();
  const [loading, setLoading] = React.useState(true);
  const [volcanoes, setVolcanoes] = React.useState<ApiVolcanoId[]>([]);
  const api = useApi();

  const fetchVolcanoes = React.useCallback(async () => {
    try {
      const response = await api.get('/volcanoes');
      const parsed = GetVolcanoIdsResponseZod.parse(response.data);
      const sortedVolcanoes = parsed.volcanoes.sort((a, b) => a.name.localeCompare(b.name));
      setVolcanoes(sortedVolcanoes);
    } catch (e) {
      setError(new Error(`Failed to fetch volcanoes: ${e}`));
    } finally {
      setLoading(false);
    }
  }, [api, setVolcanoes]);

  React.useEffect(() => {
    fetchVolcanoes();
  }, [fetchVolcanoes]);

  return {
    error,
    loading,
    volcanoes,
  };
};
